import { render, staticRenderFns } from "./business_wall.vue?vue&type=template&id=52313552&scoped=true&"
import script from "./business_wall.vue?vue&type=script&lang=js&"
export * from "./business_wall.vue?vue&type=script&lang=js&"
import style0 from "./business_wall.vue?vue&type=style&index=0&id=52313552&scoped=true&lang=css&"
import style1 from "./business_wall.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52313552",
  null
  
)

export default component.exports